module.exports = __webpack_public_path__ + "static/media/gopro.4fc036a0.jpg";